export default __webpack_public_path__ + "static/media/SAS0040.34I-32385_-17813_0.f2b70be7.jpg";